import { Pipe, PipeTransform } from '@angular/core';
import { ReportCohortBasedOn } from '../../interfaces/reports';

@Pipe({
  name: 'reportCohortBasedBy'
})
export class ReportCohortBasedByPipe implements PipeTransform {

  transform(value: ReportCohortBasedOn): string {
    const type = {
      [ReportCohortBasedOn.CREATED]: 'Cadastro',
      [ReportCohortBasedOn.EVENT]: 'Evento',
    };

    return type[value];
  }

}
